// ============================================================================= //
//  Dependencies
// ============================================================================= //
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

// ============================================================================= //
//  Project Reel
// ============================================================================= //
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const projectReels = document.querySelectorAll('.project-reel');

if ( projectReels.length ) {
	projectReels.forEach( (section) => {

		const reelHeading = section.querySelector('.project-reel__heading-content');
		const reelMedia = section.querySelector('.project-reel__media');
		const reelMediaPlay = reelMedia.querySelector('.video-play > .icon');
		const reelMediaText = reelMedia.querySelector('.video-play > .text');
		const reelDescription = section.querySelector('.project-reel__description-content');


		const setTimeline = (scene) => {
			return gsap.timeline({
				scrollTrigger: {
					trigger: scene,
					pin: true,
					scrub: true,
					// markers: true,
					start: "top top",
					end: '+=2500',
				}
			});
		};

		// Reel header
		const animateHeading = (el) => {
			return gsap.fromTo( el,
				{
					xPercent: -50,
					left: '50%',
				},
				{
					xPercent: 0,
					left: '0',
					//ease: 'power4.easeOut'
				}
			);
		};

		// Reel description
		const animateDescription = (el) => {
			return gsap.to(el, {
				xPercent: -100,
				left: '100%',
				//ease: 'power4.easeOut'
			});
		};

		// Reel media content
		const animateReel = (el) => {
			return gsap.to(el, {
				clipPath: 'inset(0% 0%)',
				maxHeight: 40 + 'vh',
			});
		};

		// Reel media play and text
		const animateReelPlay = (elements) => {
			let tl = gsap.timeline();
			elements.forEach(el => {
				tl.to(el, { opacity: 1 }, 0);
			});
			return tl;
		};

		const timeline = setTimeline(section);

		timeline
			.add(animateHeading(reelHeading))
			.add(animateDescription(reelDescription), 0)
			.add(animateReel(reelMedia), 0)
			.add(animateReelPlay([reelMediaPlay, reelMediaText]), 0.4).timeScale(6)
			.add(() => {}, "+=0.1"); // Wait before moving to the next section

	});
}
